<template>
	<nav class="navbar">
		<div class="container">
			<div class="navbar-brand">
				<a class="navbar-item is-paddingless" href="/">
					<img :src="require('@/assets/img/icon-logo.svg')" width="152" height="40" style="max-height: 40px;">
				</a>
				<a role="button" class="navbar-burger" :class="is_active?'is-active':''" @click="is_active=!is_active">
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</a>
			</div>
			<div id="navbarBasicExample" class="navbar-menu" :class="is_active?'is-active':''">
				<div class="navbar-end">
					<router-link class="navbar-item" :class="path=='/'?'is-current':''" :to="{path:'/'}">首页</router-link>
					<router-link class="navbar-item" :class="path=='/exhibition'?'is-current':''" :to="{path:'/exhibition'}">展览</router-link>
					<router-link class="navbar-item" :class="path=='/news'?'is-current':''" :to="{path:'/news'}">新闻公告</router-link>
					<router-link class="navbar-item" :class="path=='/collection'?'is-current':''" :to="{path:'/collection'}">典藏信息</router-link>
					<router-link class="navbar-item" :class="path=='/academic'?'is-current':''" :to="{path:'/academic'}">学术研究</router-link>
					<router-link class="navbar-item" :class="path=='/about'?'is-current':''" :to="{path:'/about'}">关于我们</router-link>
				</div>
			</div>
		</div>
	</nav>
</template>
<script>
export default {
	name: 'header_html',
	data() {
		return {
			is_active: false,
			is_login: false,
			index_on: 0,
			wap_nav: false,
			path: this.$route.path,
		}
	},
	// 初始事件
	mounted: function() {
		// console.log(this.$route);
	},
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header_html.vue